import React from "react";
import { Button, Input } from "reactstrap";
import { FaRegCircle, FaRegCheckCircle } from "react-icons/fa";

function Filter({
  handleCategoryChange,
  selectedCategory,
  dataCategory,
  onChangeFrom,
  onChangeTo,
  valueFrom,
  valueTo,
  handleApply,
}) {
  return (
    <div className="w-20">
      <div>
        <div className="mb-4">
          <span className="fs-24 fw-bold">Categories</span>

          <div className="mt-2 flex-column d-flex">
            <div
              className="mb-1 py-1 fs-20 align-items-center d-flex"
              onClick={handleCategoryChange}
              id="0"
            >
              {selectedCategory === "0" ? (
                <FaRegCheckCircle className="me-2 fs-24 t-primary" />
              ) : (
                <FaRegCircle className="me-2 fs-24" />
              )}
              <p className="fs">All</p>
            </div>

            {dataCategory?.map((item) => (
              <div
                className="mb-1 py-1 fs-20 align-items-center d-flex"
                key={item.id}
                id={item.id}
                onClick={handleCategoryChange}
              >
                {selectedCategory && +selectedCategory === item.id ? (
                  <FaRegCheckCircle className="me-2 fs-24 t-primary" />
                ) : (
                  <FaRegCircle className="me-2 fs-24" />
                )}
                <p className="fs">{item.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <span className="fs-24 fw-bold">Level Price</span>

          <div className="mt-3">
            <Input
              type="number"
              placeholder="From"
              className="input_price"
              onChange={onChangeFrom}
              value={valueFrom}
            />
            <Input
              type="number"
              placeholder="To"
              className="input_price mt-2"
              onChange={onChangeTo}
              value={valueTo}
            />

            <Button
              className="btn_custom w-100 btn_apply fs-6 mt-3"
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;
